"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const NotificationsPanel_1 = tslib_1.__importDefault(require("../NotificationsPanel"));
const NotificationsIcon = ({ staticNotifications, }) => {
    const [isPanelOpen, setIsPanelOpen] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(StyledButton, Object.assign({ onClick: () => { setIsPanelOpen(true); } }, { children: (0, jsx_runtime_1.jsx)("i", Object.assign({ className: 'dds-icons icon' }, { children: "notifications" })) })), (0, jsx_runtime_1.jsx)(NotificationsPanel_1.default, { isPanelOpen: isPanelOpen, setIsPanelOpen: setIsPanelOpen, staticNotifications: staticNotifications })] }));
};
exports.default = NotificationsIcon;
const StyledButton = styled_components_1.default.button `
  color: white;
  background: none;
  padding: 0.4rem;
  border: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 5rem;
  transition: box-shadow 0.26s ease 0.16s;

  &[disabled] {
    opacity: 0.3;
    pointer-events: none;
  }

  &:focus {
    outline: none;
  }

  &.active {
    transition-delay: 0s;
    background: #043134;
    border-bottom: none;
    & > i {
      color: #a2eaf4;
    }
  }

  i.dds-icons {
    display: inline-block;
    font-size: 2.4rem;
    width: 1em;
    overflow: hidden;
  }
`;
